module.exports = {"title":"A new price has been created","ok":"Got it!","description":"For your new price to be seen, you need to choose who can see the new price.","description2":"To do this, click either the \"Global Pricing Change\" button to set the visibility of all dates or click the \"Customize Pricing\" button for each event date (not in Wizard)"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/PriceAlertModal/locales/en.json
// module id = 1666
// module chunks = 0